// extracted by mini-css-extract-plugin
module.exports = {"page":"oP","account":"pP","pdp":"qP","cart":"rP","brand":"sP","cartModal":"tP","checkout":"uP"};